import type { LegStepperCopy } from '@voll-intelligence/intelligence-ui-kit';
import { genUiI18n } from './i18n.js';

/** Os textos do stepper do roteiro do kit no locale do host. Função pura, como o
 *  `flightOfferCopy`: o host memoiza por locale. */
export function legStepperCopy(locale: string | null | undefined): LegStepperCopy {
  const { t } = genUiI18n(locale);
  return {
    title: t('flightMultiOffers.title'),
    chosenCount: (chosen, total) => t('flightMultiOffers.chosenCount', { chosen, total }),
    total: t('common.total'),
    partialTotal: t('flightMultiOffers.partialTotal'),
    choosingNow: t('flightMultiOffers.choosingNow'),
    waiting: t('flightMultiOffers.waiting'),
    waitingOutbound: t('flightMultiOffers.waitingOutbound'),
    stepDone: (n) => t('flightMultiOffers.stepDone', { n }),
    removePick: (n) => t('flightExplorer.removePick', { n }),
    leg: (n) => t('flightMultiOffers.leg', { n }),
    bestOptions: (count) => t('flightMultiOffers.bestOptions', { count }),
  };
}
